import request from "@utils/request";
import url from "@utils/url";

const { HOST } = url;
// const TEST_HOST = 'http://10.1.0.85:39003'


export async function search(data) {
  const url = `${HOST}/cps-gateway/api/v1/bill/channel`;

  return request({ method: "get", url: url }, data);
}

export async function download(data) {
  const url = `${HOST}/cps-gateway/api/v1/bill/channel/detail/download`;

  return request({ method: "post", url: url, responseType: "blob" }, data);
}

export async function billDetails(data) {
  const url = `${HOST}/cps-gateway/api/v1/bill/channel/detail`;
  // const url = `${TEST_HOST}/cps-gateway/api/v1/bill/channel/detail`;

  return request({ method: "post", url: url }, data);
}

export async function getCombGames() {
  const url = `${HOST}/cps-gateway/api/v1/stat/combGame`;
  return request({ method: "get", url: url });
}
